import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as trackingDataActions from '../../actions/trackingDataActions';
import * as appHelper from '../../helpers/appHelper';
import * as keyboardConstants from '../../constants/keyboardConstants';
import * as environmentHelper from '../../helpers/environmentHelper';

class BackButton extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lesson_location: this.props.lesson_location,
            last_lesson_location: this.props.last_lesson_location,
            lang: this.props.lang,
            label: appHelper.getLocaleString("back_label"),
            env: environmentHelper.getEnvironment(),
        };
        this.onBackClick = this.onBackClick.bind(this);
        this.setBtnClass = this.setBtnClass.bind(this);
        this.setIconClass = this.setIconClass.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        if(this.state.last_lesson_location !== nextProps.last_lesson_location){
            this.setState({last_lesson_location: nextProps.last_lesson_location});
        }

        if(this.state.lesson_location !== nextProps.lesson_location){
            this.setState({lesson_location: nextProps.lesson_location});
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                label: appHelper.getLocaleString("back_label"),
            });
        }
    }

    onBackClick() {
        let disabled = false;
        if(appHelper.isDefined(this.props.disabled)){
            disabled = this.props.disabled;
        }

        if(!disabled && this.state.last_lesson_location !== 0 && this.state.last_lesson_location !== this.state.lesson_location) {
            if(this.state.last_lesson_location !== -1) {
                this.props.actions.setNewLessonLocation(this.state.last_lesson_location);
            }else {
                this.context.router.push(`menu`);
            }
        }
    }

    setBtnClass(){
        let disabled = false;
        if(appHelper.isDefined(this.props.disabled)){
            disabled = this.props.disabled;
        }
        if(this.state.last_lesson_location === 0  || this.state.last_lesson_location === this.state.lesson_location){
            disabled = true;
        }
        return disabled ? "disabled" : "";
    }

    setIconClass(){
        return "icons8-undo";
    }

    setKeyboardAccessibility(event){
        if(event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY){
            event.preventDefault();
            this.onBackClick();
        }
    }

    render() {
        return (

                (appHelper.isDefined(this.props.contentData.experience.show_icons) && this.props.contentData.experience.show_icons) || !appHelper.isDefined(this.props.contentData.experience.show_icons) || this.state.env.isDevice
                    ?
                    <div className={`header-btn back ${this.setBtnClass()}`} onClick={this.onBackClick} onKeyDown={this.setKeyboardAccessibility} role="link" tabIndex="0" aria-controls="back" title={this.state.label} aria-disabled={this.props.disabled}>
                        <div className={`icon icons8-undo `}/>
                        <div className="btn-label">{this.state.label}</div>
                    </div>
                    :
                    <div className={`header-btn`} onClick={this.onBackClick} onKeyDown={this.setKeyboardAccessibility} role="link" tabIndex="0" aria-controls="back" title={this.state.label} aria-disabled={this.props.disabled}>
                        <div className="nav-label">{this.state.label}</div>
                    </div>



        );
    }
}

BackButton.propTypes = {
    disabled: PropTypes.bool,
    last_lesson_location: PropTypes.number.isRequired,
    lesson_location: PropTypes.number.isRequired,
    lang: PropTypes.string.isRequired,
    contentData: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired

};

BackButton.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        last_lesson_location: state.trackingData.last_lesson_location,
        lesson_location: state.trackingData.lesson_location,
        contentData: state.contentData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({},trackingDataActions), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(BackButton);



/** WEBPACK FOOTER **
 ** ./src/components/buttons/BackButton.js
 **/